<template>
  <div>
    <Header>

      <template #actions>
        <BaseButton variant="secondary" color="v1-grey-10" icon="timer" size="md" @click="$router.push('/sms_history')">
          {{ $t('sms_history.btn_open') }}
        </BaseButton>
      </template>
    </Header>

    <PageContainer>
      <div class="gap-row-sm" style="height: 100%;">
        <SmsCategories style="height: fit-content; flex-shrink: 0"/>
        <SmsPricingTerms style="height: 100%;"/>
      </div>

    </PageContainer>
  </div>
</template>

<style scoped>
</style>

<script>
import SmsPricingTerms from "@/components/sms/SmsPricingTerms.vue";
import SmsCategories from "@/components/sms/SmsCategories.vue";

export default {
  components: {
    SmsPricingTerms,
    SmsCategories,
  },
};
</script>
